var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.toastrDisabled)?_c('trax-ui-toastr',{attrs:{"id":_vm.id+'-toastr',"options":_vm.toastrOptions,"labels":_vm.toastrLabels,"passed-label":_vm.toastrPassedLabel,"bus":_vm.bus}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }